<template>
  <v-row>
    <v-col cols="4" md="4">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="provinceSelected"
        clearable
        :items="provinceItems"
        :loading="provincesLoading"
        :search-input.sync="provincesSearch"
        item-text="name"
        item-value="id"
        item-disabled="disabled"
        :label="$t('Area.city_1')"
        return-object
        :single-line="dense"
        :dense="dense"
        :hide-details="dense"
        :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
      ></v-autocomplete>
    </v-col>
    <v-col cols="4" md="4">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="citySelected"
        clearable
        :items="cityItems"
        :loading="citiesLoading"
        :search-input.sync="citiesSearch"
        item-text="name"
        item-value="id"
        :label="$t('Area.city_2')"
        return-object
        :single-line="dense"
        :dense="dense"
        :hide-details="dense"
        :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
      ></v-autocomplete>
    </v-col>
    <v-col cols="4" md="4">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="districtSelected"
        clearable
        :items="districtItems"
        :loading="districtsLoading"
        :search-input.sync="districtsSearch"
        item-text="name"
        item-value="id"
        :label="$t('Area.city_3')"
        return-object
        :single-line="dense"
        :dense="dense"
        :hide-details="dense"
        :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
      ></v-autocomplete>
    </v-col>
  </v-row>
</template>
<script>
import Cities from "@/api/cities";
export default {
  name: "CitiesSelectGroup",

  props: {
    noLabel: Boolean,
    dense: Boolean,
    masterItem: Object,
  },

  data: () => ({
    provinceItems: [],
    provinceItemsObj: null,
    provinceSelected: null,
    provincesLoading: false,
    provincesSearch: "",
    cityItems: [],
    cityItemsObj: null,
    citySelected: null,
    citiesLoading: false,
    citiesSearch: "",
    districtItems: [],
    districtItemsObj: null,
    districtSelected: null,
    districtsLoading: false,
    districtsSearch: "",
  }),

  mounted() {
    //获取一级地址
    Cities.select({ rank: 1 }).then(
      function (response) {
        if (response.data.status.isOK()) {
          var cities = response.data.cities;
          this.provinceItemsObj = response.data.cities;
          var newCities = [];
          for (let i in cities) {
            newCities.push({
              id: i,
              name: cities[i],
            });
          }
          this.provinceItems = newCities;
        }
      }.bind(this)
    );
  },

  watch: {
    provinceItemsObj: {
      handler() {
        //默认选中已设置的一级地址
        if (this.masterItem.province_id && this.provinceItemsObj) {
          this.provinceSelected = {
            id: "" + this.masterItem.province_id,
            name: this.provinceItemsObj[this.masterItem.province_id],
          };
        }
      },
    },
    provinceSelected: {
      handler() {
        if (this.provinceSelected && this.provinceSelected.id) {
          //同步选择的一级地址
          this.$emit("provinceSelected", this.provinceSelected);
          //获取二级地址
          Cities.select({
            rank: 2,
            parent_city_id: this.provinceSelected.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                var cities = response.data.cities;
                this.cityItemsObj = response.data.cities;
                var newCities = [];
                for (let i in cities) {
                  newCities.push({
                    id: i,
                    name: cities[i],
                  });
                }
                this.cityItems = newCities;
              }
            }.bind(this)
          );
        } else {
          this.$emit("provinceSelected", null);
          this.cityItems = [];
          this.citySelected = null;
        }
      },
    },
    cityItems: {
      deep: true,
      handler() {
        if (this.cityItems) {
          //默认选中已设置的二级地址
          if (this.masterItem.city_id && this.cityItemsObj) {
            this.citySelected = {
              id: "" + this.masterItem.city_id,
              name: this.cityItemsObj[this.masterItem.city_id],
            };
          }
        }
      },
    },
    citySelected: {
      handler() {
        if (this.citySelected && this.citySelected.id) {
          //同步选择的二级地址
          this.$emit("citySelected", this.citySelected);
          //获取三级地址
          Cities.select({
            rank: 3,
            parent_city_id: this.citySelected.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                var cities = response.data.cities;
                this.districtItemsObj = response.data.cities;
                var newCities = [];
                for (let i in cities) {
                  newCities.push({
                    id: i,
                    name: cities[i],
                  });
                }
                this.districtItems = newCities;
              }
            }.bind(this)
          );
        } else {
          this.$emit("citySelected", null);
          this.districtItems = [];
          this.districtSelected = null;
        }
      },
    },
    districtItems: {
      deep: true,
      handler() {
        if (this.districtItems) {
          //默认选中已设置的二级地址
          if (this.masterItem.area_id && this.districtItemsObj) {
            this.districtSelected = {
              id: "" + this.masterItem.area_id,
              name: this.districtItemsObj[this.masterItem.area_id],
            };
          }
        }
      },
    },
    districtSelected: {
      handler() {
        if (this.districtSelected && this.districtSelected.id) {
          //同步选择的三级地址
          this.$emit("districtSelected", this.districtSelected);
        } else {
          this.$emit("districtSelected", null);
        }
      },
    },
  },
};
</script>